import { Action } from '@ngrx/store';
import { FilesControllerUploadDataImportFile200Response } from '../../../_generated';

export enum FileImportActionTypes {
  Set = '[File Import] Set Upload Report',
  Clear = '[File Import] Clear Upload Report',
}

export class Set implements Action {
  readonly type = FileImportActionTypes.Set;

  constructor(public payload: FilesControllerUploadDataImportFile200Response) {}
}

export class Clear implements Action {
  readonly type = FileImportActionTypes.Clear;
}

export type FileImportActions = Set | Clear;
